import { render } from "./IconHelp.vue?vue&type=template&id=10393870"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconHelp.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "10393870"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('10393870', __exports__)) {
    api.reload('10393870', __exports__)
  }
  
  module.hot.accept("./IconHelp.vue?vue&type=template&id=10393870", () => {
    api.rerender('10393870', render)
  })

}


export default __exports__